var map = {
	"./Artithon.png": "4544",
	"./Biothon.png": "2d43",
	"./Chemithon.png": "da6c",
	"./Econthon.png": "95a1",
	"./Geothon.png": "f5de",
	"./Historithon.png": "b8bc",
	"./Mathethon.png": "3343",
	"./Physithon.png": "9651",
	"./Psychothon.png": "99a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8b59";